import React from "react";
import { Button, Card, Form, Jumbotron } from "react-bootstrap";
import "./ContactUs.css";
import { useForm } from "react-hook-form";
import axios from "axios";
import swal from "sweetalert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";

const ContactUs = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    const token = await localStorage.getItem("user");

    axios
      .post("https://mysterious-sierra-48850.herokuapp.com/send-message", data, {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer" + token.token,
        },
      })
      .then((data) => {
        if (data.data.success) {
          reset();
          swal({
            title: "Thank You",
            text: data.data.message,
            icon: "success",
            button: "Ok!",
          });
        }

        // console.log(data.data);
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  return (
    <Jumbotron className="contact_use mb-0 d-flex justify-content-center align-items-center">
      <div className="row d-flex align-items-center justify-content-center">
        <div className="col-12 col-md-6">
          <div className="display-3 p-3 text-white">
            Learn more about our <span className="brand_text">Gym Club</span>
          </div>
          <div className="social_icons d-flex">
            <p className="s_icon">
              <FontAwesomeIcon icon={faFacebook} size="3x" />
            </p>
            <p className="mx-3 s_icon">
              <FontAwesomeIcon icon={faTwitter} size="3x" />
            </p>
            <p className="s_icon">
              <FontAwesomeIcon icon={faInstagram} size="3x" />
            </p>
          </div>
        </div>
        <div className="col-12 col-md-6">
          <Card
            className="p-3 mt-4 rounded shadow-lg"
            style={{ maxWidth: "100vw", minWidth: "250px" }}
          >
            <Card.Header className="text-center">
              <h2 className="brand_text">CONTACT US</h2>
            </Card.Header>
            <Card.Body>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Control
                  type="text"
                  className="m-2"
                  placeholder="Enter your Name"
                  {...register("name", { required: true })}
                />
                <Form.Control
                  type="email"
                  className="m-2"
                  placeholder="Enter a valid email address"
                  {...register("email", { required: true })}
                />
                <Form.Control
                  as="textarea"
                  rows={6}
                  className="m-2"
                  placeholder="Enter your message"
                  {...register("message", { required: true })}
                />
                <button type="submit" className="m-2 w-100">
                  Send Now
                </button>
              </Form>
            </Card.Body>
          </Card>
        </div>
      </div>
    </Jumbotron>
  );
};

export default ContactUs;
